import * as tslib_1 from "tslib";
import { Vue, Prop, Component } from 'vue-property-decorator';
import realGroup from '@/components/realGroup.vue';
import showDiv from '@ivy/fts/showDiv';
let LookSale = class LookSale extends Vue {
    constructor() {
        super(...arguments);
        this.info = {};
    }
    async mounted() {
        let { data } = await this.$axios.get(`/api/goods/shop/search/officialAccounts/info`, {
            params: {
                app_id: this.realGroupId,
            },
        });
        this.info = data;
    }
    async showQr() {
        await showDiv(realGroup, { info: this.info });
    }
};
tslib_1.__decorate([
    Prop()
], LookSale.prototype, "realGroupId", void 0);
LookSale = tslib_1.__decorate([
    Component({})
], LookSale);
export default LookSale;
